/* eslint-disable no-nested-ternary */
import type { IndicatorSelection } from "components/financials/modern/types";
import getYear from "date-fns/getYear";
import { FormattedMessage } from "react-intl";

interface SelectedIndicatorRangePeriodProps {
  selection: IndicatorSelection[];
}
export default function SelectedIndicatorRangePeriod({ selection }: SelectedIndicatorRangePeriodProps) {
  if (selection.length < 2) {
    return null;
  }
  const from = getYear(selection[0].reportDate);
  const to = getYear(selection[selection.length - 1].reportDate);

  return (
    <div className="flex flex-col items-end">
      <p className="mt-auto whitespace-nowrap text-xs font-medium tracking-wide text-slate-600 dark:text-slate-400">
        {from} → {to}{" "}
        <strong className="text-slate-800 dark:text-slate-300">
          <FormattedMessage
            defaultMessage="({years, plural, one {# ano} other {# anos}})"
            id="OPv7e1"
            values={{
              years: Math.max(to - from, 1),
            }}
          />
        </strong>
      </p>
    </div>
  );
}
